import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import { Link } from 'gatsby'
import { isExternalUrl, contentfulMapToLocalized } from "../../helpers.js"

class CallToAction extends React.Component {
  render() {
    let node = this.props.node
    let contentfulCtaElement = node.fields
    contentfulCtaElement = contentfulMapToLocalized(contentfulCtaElement)
    let renderedElement
    let extraAttributes = get(contentfulCtaElement, 'extraAttributes', {})
    if (contentfulCtaElement.type === "Anchor") {
      if (isExternalUrl(contentfulCtaElement.url)) {
        renderedElement = (<a href={contentfulCtaElement.url} target="_blank" { ...extraAttributes }>{contentfulCtaElement.label}</a>)
      } else {
        renderedElement = (<Link to={contentfulCtaElement.url} { ...extraAttributes }>{contentfulCtaElement.label}</Link>)
      }
    }
    
    const options = {}
    return (
      <div class="call-button"> { renderedElement } </div>
    )
  }
}

export default CallToAction
